import { render, staticRenderFns } from "./addCabinetDialog.vue?vue&type=template&id=58997414&scoped=true"
import script from "./addCabinetDialog.vue?vue&type=script&lang=js"
export * from "./addCabinetDialog.vue?vue&type=script&lang=js"
import style0 from "./addCabinetDialog.vue?vue&type=style&index=0&id=58997414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58997414",
  null
  
)

export default component.exports